const locale = {
  placeholder: '時刻を選択',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/ja_JP.js